import React, { FunctionComponent } from 'react'

import { RefiTransactionsCard } from './refiTransactionsCard'
import { RefiTransactionsRow } from './refiTransactionsRow'
import greenCheck from '../../assets/images/green-check.svg'
import { displayDollars } from '../../helpers/displayFormatHelper'
import { RefiTransaction } from './types'
import { NavLink } from 'react-router-dom'

export interface Props {
  refiTransaction: RefiTransaction
}

export const RefiTransactionsLoan: FunctionComponent<Props> = ({
  refiTransaction,
}) => {
  if (refiTransaction && refiTransaction.loan) {
    const {
      amountFinanced,
      beatTerms,
      cashBackAmount,
      // currentLoan,
      lienAndTitleFees,
      lienholder,
      lifetimeSavings,
      loan,
      monthlyPayment,
      monthlySavings,
      stateName,
      stateStampTax,
    } = refiTransaction

    // const currentPayment = (currentLoan || {}).payment || '0'
    const {
      id,
      externalId,
      interestRate,
      apr,
      status,
      term,
      administrativeFee,
    } = loan

    return (
      <RefiTransactionsCard
        titleRight={
          status === 'QUALIFIED' ? (
            <div className="refi-transactions-loan__qualified">
              Qualified
              <img src={greenCheck} alt="" />
            </div>
          ) : (
            status
          )
        }
        title="NEW LOAN"
      >
        {beatTerms && (
          <RefiTransactionsRow
            field="Can beat terms"
            valuesBold
            hasBottomBorder
          >
            Yes
          </RefiTransactionsRow>
        )}
        <RefiTransactionsRow field="Loan ID" valuesBold>
          {id}
          {id && (
            <NavLink
              className="refi-transactions-loan__edit-terms-link"
              to={`/refinance/${id}/loan-history`}
            >
              View Loan History
            </NavLink>
          )}
        </RefiTransactionsRow>
        <RefiTransactionsRow field="External ID" valuesBold>
          {externalId}
        </RefiTransactionsRow>
        {interestRate && (
          <RefiTransactionsRow field="Interest rate" valuesBold>
            {`${interestRate}%`}
          </RefiTransactionsRow>
        )}
        {lienholder && lienholder.totalPayoffAmount && (
          <RefiTransactionsRow field="Verified balance" valuesBold>
            {displayDollars(lienholder.totalPayoffAmount)}
          </RefiTransactionsRow>
        )}
        {cashBackAmount && (
          <RefiTransactionsRow field="Cash back" valuesBold>
            {displayDollars(cashBackAmount)}
          </RefiTransactionsRow>
        )}
        {lienAndTitleFees && (
          <RefiTransactionsRow field="Lien and title fees" valuesBold>
            {displayDollars(lienAndTitleFees)}
          </RefiTransactionsRow>
        )}
        {stateName === 'FL' && (
          <RefiTransactionsRow
            field="Public Official - documentary stamp taxes"
            valuesBold
          >
            {displayDollars(stateStampTax)}
          </RefiTransactionsRow>
        )}
        {administrativeFee && (
          <RefiTransactionsRow field="Administrative fees" valuesBold>
            {displayDollars(administrativeFee)}
          </RefiTransactionsRow>
        )}
        {amountFinanced && (
          <RefiTransactionsRow field="Borrowed total" valuesBold>
            {displayDollars(amountFinanced)}
          </RefiTransactionsRow>
        )}
        {apr && (
          <RefiTransactionsRow field="APR" valuesBold hasBottomBorder>
            {`${apr}%`}
          </RefiTransactionsRow>
        )}
        {refiTransaction.term && (
          <RefiTransactionsRow field="Selected loan term" valuesBold>
            {`${refiTransaction.term} months`}
            <NavLink
              className="refi-transactions-loan__edit-terms-link"
              to={`/refinance/${refiTransaction.id}/editloanterm`}
            >
              Change
            </NavLink>
          </RefiTransactionsRow>
        )}
        {monthlyPayment && (
          <RefiTransactionsRow field="Monthly payment" valuesBold>
            {displayDollars(monthlyPayment)}
          </RefiTransactionsRow>
        )}
        {monthlySavings && term && (
          <RefiTransactionsRow field="Lifetime savings" valuesBold>
            {displayDollars(lifetimeSavings)}
          </RefiTransactionsRow>
        )}
      </RefiTransactionsCard>
    )
  } else {
    return <RefiTransactionsCard title="NEW LOAN" />
  }
}

RefiTransactionsLoan.displayName = 'RefiTransactionsLoan'
